import React from "react";

export const pricingPlans = [
  {
    title: "????",
    price: "TBD",
    priceDescription: "/month",
    description:
      "We are still figuring out our pricing models. In any case, you can use your cloud GPU whenever, however, and wherever you want.",
    buttonText: "Coming soon!",
    buttonClass: "bg-white text-black",
    disabled: true,
    href: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
  },
  {
    title: "Beta Access",
    price: "Free",
    priceDescription: "during refray beta",
    pricePrefix: "",
    description:
      "Get everything we have to offer while we build refray into something amazing. After the beta, we'll give a lifetime discount and a special surprise if you buy!",
    buttonText: "Request beta access",
    buttonClass: "bg-primary text-white",
    href: "https://tally.so/r/mJvlzo"
  },
];

export default function Pricing() {
  return (
    <section
      id="pricing"
      className="px-4 md:py-12 max-w-[1200px] mx-auto text-white"
      data-aos="fade-up"
      data-aos-duration="800"
    >
      <h2
        className="text-[2.5rem] md:text-[4.5rem] max-w-5xl pb-10 text-center mx-auto"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        The last hardware upgrade you'll ever need
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        {pricingPlans.map((plan, i) => (
          <div
            key={plan.title}
            className="bg-card shadow-lg p-6 md:p-8 flex flex-col justify-between"
            data-aos="fade-up"
            data-aos-delay={200 + i * 100}
          >
            <div>
              <div className="text-center w-full mb-2">
                {plan.pricePrefix && (
                  <p className="text-base font-light">{plan.pricePrefix}</p>
                )}
                <p className="text-4xl font-bold">{plan.price}</p>
                <p className="text-base font-light">{plan.priceDescription}</p>
              </div>
              <h3
                className='text-center mt-2 mb-6 text-4xl'
              >
                {plan.title}
              </h3>
              <p className="text-xl leading-relaxed text-center mt-4 mb-6 mx-auto">
                {plan.description}
              </p>
            </div>
            <a href={plan.href}>
              <button className={`${plan.buttonClass} w-full py-4 px-6 mt-6 text-xl hover:bg-opacity-75 transition ${plan.disabled ? `hover:cursor-not-allowed` : ""}`}>
                {plan.buttonText}
              </button>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}